
import { defineComponent, SetupContext, computed } from "vue";
import { transleteCoolingModeToDisplayString } from "@/utils/fridgeDetails-utils"
import NativeClient from "@/client/native-client";
import { FRIDGE_DETAILS_COOLING_MODE } from "@/types/fridgeDetails"

export default defineComponent({
  name: "FridgeSettingsQuickButtonItem",
  props: {
    /** モード */
    mode: {
      type: String,
      required: true
    },
    /** 名前 */
    name: {
      type: String,
      required: true
    },
    /** 分 */
    minutes: {
      type: Number,
      required: true
    },
    /** 秒 */
    seconds: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeSettingsQuickButtonItem setup start");
    const modeText = computed(() => {
      return transleteCoolingModeToDisplayString(props.mode);
    });

    // ボタンを押す回数
    const pushCountText = computed(() => {
      let result = "";
      switch (props.mode) {
        case FRIDGE_DETAILS_COOLING_MODE.QUENCH:
          result = "（ボタン1回押し）";
          break;
        case FRIDGE_DETAILS_COOLING_MODE.COLD:
          result = "（ボタン2回押し）";
          break;
        case FRIDGE_DETAILS_COOLING_MODE.FROZEN:
          result = "（ボタン3回押し）";
          break;
        default:
          break;
      }
      return result;
    });

    // 設定時間
    const timeText = computed(() => {
    let result = "";
      switch (props.mode) {
        case FRIDGE_DETAILS_COOLING_MODE.QUENCH:
          {
            const secondsText = ( '00' + props.seconds ).slice( -2 );
            result = `${props.minutes}分${secondsText}秒`;
          }
          break;
        default:
          result = `${props.minutes}分`;
          break;
      }
      return result;
    });

    const clickQuickbutton = () => {
      NativeClient.sendDebugLog("FridgeSettingsQuickButtonItem click = " + props.mode);
      context.emit("click-quick", props.mode);
    };

    return {
      modeText,
      pushCountText,
      timeText,
      clickQuickbutton
    };
}
});
